<form class="admin-filters" nz-form [formGroup]="searchForm" (ngSubmit)="submitFilterForm()">
  <div class="admin-filters__fields">
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            formControlName="searchTerm"
            nz-input
            [placeholder]="'admin.filter.search.placeholder' | translate"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span *ngIf="!searchForm.get('searchTerm')?.value" nz-icon nzType="search"></span>
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="searchForm.get('searchTerm')?.value"
            (click)="searchForm.get('searchTerm')?.setValue(null)"
          ></span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- 1. Sector -->
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzSize="default"
          formControlName="sector"
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.sector.placeholder' | translate"
        >
          <nz-option
            [nzLabel]="option.name | translate"
            [nzValue]="option.value"
            *ngFor="let option of sector$ | async"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 2. Industries -->
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.industry.placeholder' | translate"
          formControlName="industry"
        >
          <nz-option
            [nzLabel]="option.name | translate"
            [nzValue]="option.value"
            *ngFor="let option of industry$ | async"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 3. Department -->
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'profile.department.label' | translate"
          formControlName="wishDepartment"
        >
          <nz-option
            [nzLabel]="option.name | translate"
            [nzValue]="option.value"
            *ngFor="let option of department$ | async"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 4. Area of Expertise -->
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.expert-fields.placeholder' | translate"
          formControlName="expertFields"
        >
          <nz-option
            [nzLabel]="option.name | translate"
            [nzValue]="option.value"
            *ngFor="let option of expertFields$ | async"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 5. Career Level -->
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.careerLevel.placeholder' | translate"
          formControlName="careerLevel"
        >
          <nz-option
            [nzLabel]="option.name | translate"
            [nzValue]="option.value"
            *ngFor="let option of careerLevel$ | async"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <!-- 6. Degree -->
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzMode="multiple"
          nzSize="default"
          formControlName="degree"
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.degree.placeholder' | translate"
        >
          <nz-option
            [nzLabel]="option.name | translate"
            [nzValue]="option.value"
            *ngFor="let option of degree$ | async"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <mh-salary-expectation-input
      formControlName="salary"
      [usePlaceholder]="true"
      [limitMaxOptions]="false"
      class="admin-filters__field"
    ></mh-salary-expectation-input>

    <mh-location-input
      formControlName="location"
      [zipOnly]="true"
      [distanceInput]="true"
      [groupValidators]="searchForm.get('location')?.validator"
      [groupError]="!!searchForm.get('location')?.hasError('zip')"
      [mark]="searchForm.get('location')?.dirty || false"
      class="admin-filters__field"
    ></mh-location-input>

    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-range-picker formControlName="timeRange" class="admin-filters__field"></nz-range-picker>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzSize="default"
          formControlName="profileFilled"
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.profile-fill.placeholder' | translate"
        >
          <nz-option [nzLabel]="'admin.filter.profile-fill.filled' | translate" [nzValue]="true"></nz-option>
          <nz-option [nzLabel]="'admin.filter.profile-fill.not-filled' | translate" [nzValue]="false"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzSize="default"
          formControlName="openStatus"
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.open-status.placeholder' | translate"
        >
          <nz-option [nzLabel]="'admin.filter.open-status.searching' | translate" [nzValue]="true"></nz-option>
          <nz-option [nzLabel]="'admin.filter.open-status.not-searching' | translate" [nzValue]="false"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div class="admin-filters__actions admin-filters__actions--talent-list">
    <nz-form-item>
      <nz-form-control>
        <button
          nz-button
          nzBlock
          nzType="default"
          type="button"
          [disabled]="isApiLoading"
          (click)="downloadTalentListCSV()"
        >
          <span nz-icon [nzType]="isApiLoading ? 'loading' : 'download'" nzTheme="outline"></span>
          {{ "admin.download.csv" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <nz-form-label nzFor="additionalInfo">{{
          "admin.talent-list.additional-info.switch" | translate
        }}</nz-form-label>
        <nz-switch formControlName="additionalInfo" id="additionalInfo"></nz-switch>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="admin-filters__submit">
      <nz-form-control>
        <button nz-button nzBlock nzType="primary" [disabled]="!searchForm.valid">
          {{ "admin.filter.submit" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>

<mh-admin-talent-statistic [stats]="tableState.data?.additionalData['statistic']"></mh-admin-talent-statistic>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>

<div class="desktop-only" *ngIf="(isMobileLayout$ | async) === false">
<nz-table
  class="sticky-table"
  #basicTable
  [nzData]="tableState.data?.items || []"
  nzPaginationPosition="both"
  nzShowSizeChanger="true"
  nzSize="small"
  [nzShowTotal]="rangeTemplate"
  nzFrontPagination="false"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.data?.paging?.items || 0"
  [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
  [nzPageIndex]="tableState.data?.paging?.page || 0"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th nzColumnKey="NAME" [nzSortFn]="true">
        <div>
          {{ "admin.user-name.title" | translate }}
        </div>
        <div *ngIf="showAdditionalInfo" class="subtitle">
          {{ "admin.career-level.title" | translate }} / {{ "admin.industries.title" | translate }}
        </div>
      </th>
      <th nzColumnKey="EMAIL" [nzSortFn]="true">
        <div>
          {{ "admin.email.title" | translate }}
        </div>
        <div *ngIf="showAdditionalInfo" class="subtitle">
          {{ "admin.salary-expectations.title" | translate }} / {{ "admin.job-titles.title" | translate }}
        </div>
      </th>
      <th nzColumnKey="STATUS" [nzSortFn]="true">
        <div>
          {{ "admin.status.title" | translate }}
        </div>
        <div *ngIf="showAdditionalInfo" class="subtitle">
          {{ "admin.sector.title" | translate }} / {{ "admin.city.title" | translate }}
        </div>
      </th>
      <th nzColumnKey="REG_TIMESTAMP" [nzSortFn]="true" nzSortOrder="descend">
        <div>
          {{ "admin.registered.title" | translate }}
        </div>
        <div *ngIf="showAdditionalInfo" class="subtitle">
          {{ "admin.courses-of-study.title" | translate }}
        </div>
      </th>
      <th>
        <div>
          {{ "admin.action.title" | translate }}
        </div>
        <div *ngIf="showAdditionalInfo" class="subtitle">
          {{ "admin.expert-fields.title" | translate }}
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of basicTable.data; let i = index">
      <tr class="main-row" [class.main-row--hover]="hoveredRowIndex === i">
        <td>
          <a [routerLink]="['/admin/talent-view', data.accountId.internalId]" target="_blank">
            {{ data.salutation }} {{ data.firstName }} {{ data.lastName }}
          </a>
          <a *ngIf="data.crossRegistered" [href]="appConfig.crossPlatformUrl + '/admin/talent-view/' + data.crossRegisteredAccountId" target="_blank" (click)="$event.stopPropagation()">
            <img
              class="cross-registered-logo"
              [class.cross-registered-logo--flextalent]="appConfig.brand === 'flextalent'"
              src="/assets/images/logo-cross-registered.svg"
              alt="Cross registered"
            />
          </a>

          <button
            *ngIf="data.fullTextSearchResult"
            nz-button
            nzType="link"
            nzSize="small"
            nz-popover
            nzPopoverPlacement="top"
            [nzPopoverContent]="highlightContent"
            nzPopoverTitle=""
          >
            <span nz-icon nzType="search" nzTheme="outline"></span>
            <ng-template #highlightContent>
              <div [innerHTML]="data.highlight" style="white-space: pre-line"></div>
            </ng-template>
          </button>
        </td>
        <td>{{ data.email }}</td>
        <td>
          <span *ngFor="let s of data.statuses" [attr.data-tooltip]="s">{{ getStatusShortName(s) }}</span>
        </td>
        <td>{{ data.registrationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}</td>
        <td class="nowrap">
          <button
            *ngIf="canWrite"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.sign-in-as.tooltip' | translate"
            (click)="onSignInAs(data.accountId.internalId)"
          >
            <span nz-icon nzType="login" nzTheme="outline"></span>
          </button>

          <button
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="data.accountId.internalId"
            (click)="copyId(data.accountId.internalId)"
          >
            <span nz-icon nzType="info-circle" nzTheme="outline"></span>
          </button>

          <button
            *ngIf="canWrite && data.communityMember"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.community-member-status.tooltip' | translate"
            (click)="setCommunityMemberStatus(data)"
          >
            <span nz-icon nzType="check-circle" nzTheme="fill"></span>
          </button>
          <button
            *ngIf="canWrite && !data.communityMember"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.community-member-status.tooltip' | translate"
            (click)="setCommunityMemberStatus(data)"
          >
            <span nz-icon nzType="check-circle" nzTheme="outline"></span>
          </button>

          <button
            *ngIf="canWrite"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.confirmed-status.tooltip' | translate"
            (click)="setConfirmedStatus(data)"
          >
            <span
              nz-icon
              nzType="mail"
              [nzTheme]="data.statuses.includes(AccountStatus.CONFIRMED) ? 'fill' : 'outline'"
            ></span>
          </button>

          <button
            *ngIf="canWrite"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.manual-match.tooltip' | translate"
            (click)="openManualMatchModal(data)"
          >
            <span nz-icon style="transform: scale(1.3)">
              <svg viewBox="0 0 512 512">
                <g transform="translate(0,512) scale(0.1,-0.1)" fill="currentColor" stroke="none">
                  <path
                    d="M3840 4010 c-157 -38 -347 -84 -423 -103 l-138 -34 -467 94 c-598 120 -649 122 -847 23 l-80 -40 -245 -2 -245 -3 -58 -29 c-91 -46 -162 -134 -200 -247 -3 -9 -72 -54 -154 -100 -218 -124 -321 -229 -388 -396 -13 -32 -62 -238 -110 -458 -92 -425 -96 -464 -60 -536 39 -78 109 -128 218 -159 58 -16 59 -17 77 -69 9 -28 31 -69 47 -89 36 -46 112 -98 161 -112 93 -25 212 -3 287 55 19 14 62 62 96 106 33 44 62 79 64 77 1 -2 31 -70 65 -153 72 -171 104 -223 163 -267 184 -134 430 -77 533 124 22 42 28 71 32 138 l4 85 -118 330 -119 330 0 95 c0 84 3 101 28 150 39 76 108 143 181 177 53 24 73 28 151 28 76 0 99 -4 145 -26 67 -31 225 -162 264 -217 89 -129 88 -295 -4 -515 -46 -111 -109 -199 -235 -327 -70 -72 -122 -135 -139 -167 -33 -66 -56 -154 -56 -213 1 -73 26 -195 53 -254 72 -157 260 -257 428 -227 147 25 238 98 319 251 85 161 201 271 343 324 34 13 119 35 188 49 151 31 228 56 333 108 151 75 285 186 386 321 40 52 81 93 119 119 124 83 230 225 277 374 63 200 55 533 -21 815 -47 174 -140 380 -222 493 -65 88 -186 148 -296 146 -29 0 -180 -31 -337 -69z m405 -101 c62 -17 115 -80 183 -221 92 -189 141 -358 163 -563 13 -127 6 -319 -16 -414 -33 -137 -129 -269 -253 -346 -43 -26 -72 -54 -106 -105 -137 -201 -372 -349 -623 -395 -334 -61 -522 -188 -655 -443 -57 -109 -70 -124 -130 -157 -120 -67 -274 -19 -338 105 -24 48 -44 172 -35 228 12 80 43 127 164 250 129 131 199 233 257 375 93 229 98 438 13 598 -48 90 -231 260 -340 315 -251 127 -576 19 -702 -233 -46 -94 -61 -167 -54 -273 4 -77 16 -117 122 -414 109 -305 117 -333 113 -387 -3 -46 -11 -67 -34 -96 -40 -51 -96 -77 -159 -77 -57 1 -98 19 -137 61 -17 18 -105 214 -249 553 -221 523 -222 525 -226 611 -9 150 -13 144 420 576 382 381 409 404 514 432 92 25 165 16 661 -84 l481 -96 328 80 c599 146 566 140 638 120z m-2525 -122 c0 -1 -119 -121 -265 -267 l-265 -265 20 70 c11 39 37 130 57 203 43 157 73 210 134 240 39 19 61 22 182 22 75 0 137 -1 137 -3z m-823 -986 c-114 -406 -177 -617 -188 -624 -12 -7 -31 -3 -71 15 -95 44 -95 28 1 476 45 211 91 409 102 438 30 80 95 171 158 220 61 48 165 107 168 96 2 -4 -75 -283 -170 -621z m292 -370 l111 -264 -25 -36 c-67 -96 -144 -188 -175 -209 -29 -20 -44 -23 -93 -20 -46 4 -63 10 -88 34 -34 32 -59 81 -59 116 0 13 38 158 84 323 46 165 90 320 96 345 l13 45 12 -35 c7 -19 63 -154 124 -299z"
                  />
                </g>
              </svg>
            </span>
          </button>

          <button
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.match-criteria.tooltip' | translate"
            (click)="openMatchCriteriaModal(data)"
          >
            <span nz-icon nzType="audit" nzTheme="outline"></span>
          </button>

          <button
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.password-reset-email.tooltip' | translate"
            (click)="sendPasswordResetEmail(data.accountId, data.email)"
          >
            <span nz-icon nzType="send" nzTheme="outline"></span>
          </button>

          <button
            *ngIf="canWrite"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.set-password.tooltip' | translate"
            (click)="openSetPasswordModal(data)"
          >
            <span nz-icon nzType="lock" nzTheme="outline"></span>
          </button>

          <button
            *ngIf="canWrite"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.comment.tooltip' | translate"
            (click)="openCommentModal(data)"
          >
            <span
              nz-icon
              nzType="message"
              [nzTheme]="data.commentsExist ? 'fill' : 'outline'"
              [class.comment-icon--active]="data.commentsExist"
            ></span>
          </button>

          <a
            *ngIf="data.cvExist"
            [href]="data.cvUrl"
            target="_blank"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.cv.tooltip' | translate"
          >
            <span nz-icon nzType="file-text" nzTheme="fill"></span>
          </a>

          <button
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.export-data.tooltip' | translate"
            (click)="downloadData(data.accountId)"
          >
            <span nz-icon nzType="database" nzTheme="outline"></span>
          </button>

          <button
            *ngIf="canWrite"
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.delete-account.tooltip' | translate"
            (click)="showDeleteConfirm(data)"
          >
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>

          <button
            nz-button
            nzType="link"
            nzSize="small"
            [attr.data-tooltip]="'admin.export-talent-to-brevo.label' | translate"
            (click)="exportTalentToBrevo(data)"
          >
            <span nz-icon nzType="export" nzTheme="outline"></span>
          </button>
        </td>
      </tr>
      <tr
        *ngIf="showAdditionalInfo"
        class="sub-row"
        (mouseenter)="hoveredRowIndex = i"
        (mouseleave)="hoveredRowIndex = null"
      >
        <td>
          <nz-tag
            *ngIf="data.careerLevel?.name"
            nzColor="#FDF2D0"
            class="tag"
            [title]="data.careerLevel.name | translate"
          >
            {{ data.careerLevel.name | translate }}
          </nz-tag>
          <mh-tags-output
            [value]="data.industries"
            [sortABC]="true"
            nzColor="#D77A6B"
            tagClass="tag"
            placeholder=""
          ></mh-tags-output>
        </td>
        <td>
          <mh-tags-output
            *ngIf="data.salaryExpectations && (data.salaryExpectations.min || data.salaryExpectations.max)"
            tagClass="tag"
            nzColor="#DCEAD5"
            [sortABC]="true"
            [value]="[getSalaryExpectationLabel(data.salaryExpectations)]"
            placeholder=""
          ></mh-tags-output>
          <mh-tags-output [value]="data.jobTitles" nzColor="#CA93AF" tagClass="tag" placeholder=""></mh-tags-output>
        </td>
        <td>
          <nz-tag *ngIf="data.sector?.name" nzColor="#A594CC" class="tag" [title]="data.sector.name | translate">
            {{ data.sector.name | translate }}
          </nz-tag>
          <nz-tag *ngIf="data.city" nzColor="#93B3F1" class="tag" [title]="data.city">
            {{ data.city }}
          </nz-tag>
        </td>
        <td>
          <mh-tags-output
            [value]="data.coursesOfStudy"
            [sortABC]="true"
            nzColor="#FDE187"
            tagClass="tag"
            placeholder=""
          ></mh-tags-output>
        </td>
        <td>
          <mh-tags-output
            [value]="data.expertFields"
            [sortABC]="true"
            tagClass="tag"
            nzColor="#92B8BD"
            placeholder=""
          ></mh-tags-output>
        </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>
</div>

<div class="mobile-only" *ngIf="isMobileLayout$ | async" style="margin-top: 16px;">
  <div *ngIf="!tableState.loading && (tableState.data?.items?.length || 0) > 0" style="margin-bottom: 16px; text-align: center;">
    <nz-pagination
      [nzPageIndex]="tableState.data?.paging?.page || 0"
      [nzTotal]="tableState.data?.paging?.items || 0"
      [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
      (nzPageIndexChange)="onPageChange($event)"
      [nzSize]="'small'">
    </nz-pagination>
  </div>

  <nz-spin [nzSpinning]="tableState.loading">
    <div style="display: flex; flex-direction: column; gap: 16px;">
      <nz-card *ngFor="let data of tableState.data?.items || []; let i = index" nzHoverable>
        
        <div nz-row [nzGutter]="[16, 16]">
        
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="6">
          <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.user-name.title" | translate }}:</span>
          <a [routerLink]="['/admin/talent-view', data.accountId.internalId]" target="_blank" style="font-weight: 500;">
            {{ data.salutation }} {{ data.firstName }} {{ data.lastName }}
          </a>
          <a *ngIf="data.crossRegistered" [href]="appConfig.crossPlatformUrl + '/admin/talent-view/' + data.crossRegisteredAccountId" target="_blank" (click)="$event.stopPropagation()">
            <img
              class="cross-registered-logo"
              [class.cross-registered-logo--flextalent]="appConfig.brand === 'flextalent'"
              src="/assets/images/logo-cross-registered.svg"
              alt="Cross registered"
              style="display: block; margin-top: 4px;"
            />
          </a>
          <button
            *ngIf="data.fullTextSearchResult"
            nz-button
            nzType="link"
            nzSize="small"
            nz-popover
            nzPopoverPlacement="top"
            [nzPopoverContent]="highlightContent"
            nzPopoverTitle=""
            style="padding: 0;"
          >
            <span nz-icon nzType="search" nzTheme="outline"></span>
            <ng-template #highlightContent>
              <div [innerHTML]="data.highlight" style="white-space: pre-line"></div>
            </ng-template>
          </button>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="6">
          <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.email.title" | translate }}:</span>
          {{ data.email }}
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="6">
          <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.status.title" | translate }}:</span>
          <span *ngFor="let s of data.statuses" [attr.data-tooltip]="s" style="margin-right: 4px;">{{ getStatusShortName(s) }}</span>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="6">
          <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.registered.title" | translate }}:</span>
          {{ data.registrationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}
        </div>
      </div>

      <div *ngIf="showAdditionalInfo" style="margin-top: 16px; border-top: 1px dashed #ebedf0; padding-top: 16px;">
        <div nz-row [nzGutter]="[16, 16]">
          
          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="8">
            <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.career-level.title" | translate }} / {{ "admin.industries.title" | translate }}:</span>
            <nz-tag
              *ngIf="data.careerLevel?.name"
              nzColor="#FDF2D0"
              class="tag"
              [title]="data.careerLevel.name | translate"
            >
              {{ data.careerLevel.name | translate }}
            </nz-tag>
            <mh-tags-output
              [value]="data.industries"
              [sortABC]="true"
              nzColor="#D77A6B"
              tagClass="tag"
              placeholder=""
            ></mh-tags-output>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="8">
            <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.salary-expectations.title" | translate }} / {{ "admin.job-titles.title" | translate }}:</span>
            <mh-tags-output
              *ngIf="data.salaryExpectations && (data.salaryExpectations.min || data.salaryExpectations.max)"
              tagClass="tag"
              nzColor="#DCEAD5"
              [sortABC]="true"
              [value]="[getSalaryExpectationLabel(data.salaryExpectations)]"
              placeholder=""
            ></mh-tags-output>
            <mh-tags-output [value]="data.jobTitles" nzColor="#CA93AF" tagClass="tag" placeholder=""></mh-tags-output>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="8">
            <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.sector.title" | translate }} / {{ "admin.city.title" | translate }}:</span>
            <nz-tag *ngIf="data.sector?.name" nzColor="#A594CC" class="tag" [title]="data.sector.name | translate">
              {{ data.sector.name | translate }}
            </nz-tag>
            <nz-tag *ngIf="data.city" nzColor="#93B3F1" class="tag" [title]="data.city">
              {{ data.city }}
            </nz-tag>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="12" [nzXl]="8">
            <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.courses-of-study.title" | translate }}:</span>
            <mh-tags-output
              [value]="data.coursesOfStudy"
              [sortABC]="true"
              nzColor="#FDE187"
              tagClass="tag"
              placeholder=""
            ></mh-tags-output>
          </div>

          <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" [nzXl]="16">
            <span style="font-size: 12px; opacity: 0.65; font-weight: 500; display: block; margin-bottom: 4px;">{{ "admin.expert-fields.title" | translate }}:</span>
            <mh-tags-output
              [value]="data.expertFields"
              [sortABC]="true"
              tagClass="tag"
              nzColor="#92B8BD"
              placeholder=""
            ></mh-tags-output>
          </div>
        </div>
      </div>

      <nz-divider></nz-divider>

      <div style="display: flex; flex-wrap: wrap; gap: 8px;">
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" (click)="onSignInAs(data.accountId.internalId)">
          <span nz-icon nzType="login"></span> Sign In
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="copyId(data.accountId.internalId)">
          <span nz-icon nzType="info-circle"></span> Copy ID
        </button>
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" (click)="setCommunityMemberStatus(data)">
          <span nz-icon nzType="check-circle" [nzTheme]="data.communityMember ? 'fill' : 'outline'"></span> Community
        </button>
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" (click)="setConfirmedStatus(data)">
          <span nz-icon nzType="mail" [nzTheme]="data.statuses.includes(AccountStatus.CONFIRMED) ? 'fill' : 'outline'"></span> Confirm
        </button>
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" (click)="openManualMatchModal(data)">
          <span nz-icon><svg viewBox="0 0 512 512" width="14" height="14"><g transform="translate(0,512) scale(0.1,-0.1)" fill="currentColor" stroke="none"><path d="M3840 4010 c-157 -38 -347 -84 -423 -103 l-138 -34 -467 94 c-598 120 -649 122 -847 23 l-80 -40 -245 -2 -245 -3 -58 -29 c-91 -46 -162 -134 -200 -247 -3 -9 -72 -54 -154 -100 -218 -124 -321 -229 -388 -396 -13 -32 -62 -238 -110 -458 -92 -425 -96 -464 -60 -536 39 -78 109 -128 218 -159 58 -16 59 -17 77 -69 9 -28 31 -69 47 -89 36 -46 112 -98 161 -112 93 -25 212 -3 287 55 19 14 62 62 96 106 33 44 62 79 64 77 1 -2 31 -70 65 -153 72 -171 104 -223 163 -267 184 -134 430 -77 533 124 22 42 28 71 32 138 l4 85 -118 330 -119 330 0 95 c0 84 3 101 28 150 39 76 108 143 181 177 53 24 73 28 151 28 76 0 99 -4 145 -26 67 -31 225 -162 264 -217 89 -129 88 -295 -4 -515 -46 -111 -109 -199 -235 -327 -70 -72 -122 -135 -139 -167 -33 -66 -56 -154 -56 -213 1 -73 26 -195 53 -254 72 -157 260 -257 428 -227 147 25 238 98 319 251 85 161 201 271 343 324 34 13 119 35 188 49 151 31 228 56 333 108 151 75 285 186 386 321 40 52 81 93 119 119 124 83 230 225 277 374 63 200 55 533 -21 815 -47 174 -140 380 -222 493 -65 88 -186 148 -296 146 -29 0 -180 -31 -337 -69z m405 -101 c62 -17 115 -80 183 -221 92 -189 141 -358 163 -563 13 -127 6 -319 -16 -414 -33 -137 -129 -269 -253 -346 -43 -26 -72 -54 -106 -105 -137 -201 -372 -349 -623 -395 -334 -61 -522 -188 -655 -443 -57 -109 -70 -124 -130 -157 -120 -67 -274 -19 -338 105 -24 48 -44 172 -35 228 12 80 43 127 164 250 129 131 199 233 257 375 93 229 98 438 13 598 -48 90 -231 260 -340 315 -251 127 -576 19 -702 -233 -46 -94 -61 -167 -54 -273 4 -77 16 -117 122 -414 109 -305 117 -333 113 -387 -3 -46 -11 -67 -34 -96 -40 -51 -96 -77 -159 -77 -57 1 -98 19 -137 61 -17 18 -105 214 -249 553 -221 523 -222 525 -226 611 -9 150 -13 144 420 576 382 381 409 404 514 432 92 25 165 16 661 -84 l481 -96 328 80 c599 146 566 140 638 120z m-2525 -122 c0 -1 -119 -121 -265 -267 l-265 -265 20 70 c11 39 37 130 57 203 43 157 73 210 134 240 39 19 61 22 182 22 75 0 137 -1 137 -3z m-823 -986 c-114 -406 -177 -617 -188 -624 -12 -7 -31 -3 -71 15 -95 44 -95 28 1 476 45 211 91 409 102 438 30 80 95 171 158 220 61 48 165 107 168 96 2 -4 -75 -283 -170 -621z m292 -370 l111 -264 -25 -36 c-67 -96 -144 -188 -175 -209 -29 -20 -44 -23 -93 -20 -46 4 -63 10 -88 34 -34 32 -59 81 -59 116 0 13 38 158 84 323 46 165 90 320 96 345 l13 45 12 -35 c7 -19 63 -154 124 -299z" /></g></svg></span> Match
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="openMatchCriteriaModal(data)">
          <span nz-icon nzType="audit"></span> Criteria
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="sendPasswordResetEmail(data.accountId, data.email)">
          <span nz-icon nzType="send"></span> Reset
        </button>
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" (click)="openSetPasswordModal(data)">
          <span nz-icon nzType="lock"></span> Set Pwd
        </button>
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" (click)="openCommentModal(data)">
          <span nz-icon nzType="message" [nzTheme]="data.commentsExist ? 'fill' : 'outline'"></span> Comment
        </button>
        <a *ngIf="data.cvExist" [href]="data.cvUrl" target="_blank" nz-button nzType="default" nzSize="small">
          <span nz-icon nzType="file-text"></span> CV
        </a>
        <button nz-button nzType="default" nzSize="small" (click)="downloadData(data.accountId)">
          <span nz-icon nzType="database"></span> Export
        </button>
        <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" nzDanger (click)="showDeleteConfirm(data)">
          <span nz-icon nzType="delete"></span> Delete
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="exportTalentToBrevo(data)">
          <span nz-icon nzType="export"></span> Brevo
        </button>
      </div>
    </nz-card>
    </div>
  </nz-spin>
  <div *ngIf="!tableState.loading && (tableState.data?.items?.length || 0) > 0" style="margin-top: 16px; text-align: center;">
    <nz-pagination
      [nzPageIndex]="tableState.data?.paging?.page || 0"
      [nzTotal]="tableState.data?.paging?.items || 0"
      [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
      (nzPageIndexChange)="onPageChange($event)"
      nzShowSizeChanger="false"
      nzSize="small"
    ></nz-pagination>
  </div>
</div>
